module.exports = "<div class=\"footer\"\n     [hidden]=\"isSmallView\">\n    <img src=\"./assets/fe.png\">\n    <img src=\"./assets/220px-GUGiK_logo.svg.png\">\n    <img src=\"./assets/fzsin.png\">\n    <img src=\"./assets/uef.png\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main